import React from 'react';
import { Fade } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import { img_url19,img_url20,img_url21 } from '../Constant/Constants';
import "../Landingpage/Landing.css"
// import img1 from "../Images/img.jpg"
// import img2 from "../Images/img2.jpg"
// import img3 from "../Images/img3.jpg"

const fadeImages = [
  {
  url: img_url19,
  caption: '...'
  },
  {
  url: img_url20,
  caption: '...'
  },
  {
  url: img_url21,
  caption: '...'
  },
  // {img_url10},{img_url11},{img_url12}
  // img1,img2,img3
];

const Bslideshow = () => {
  return (
    <div className="slide-container">
      <Fade>
        {fadeImages.map((fadeImage, index) => (
          <div className="each-fade" key={index}>
            <div className="image-container">
              <img src={fadeImage.url} />
            </div>
            <h2>{fadeImage.caption}</h2>
          </div>
        ))}
      </Fade>
    </div>
  )
}

export default Bslideshow